module.exports = __webpack_public_path__ + "img/idcards.7b08ef30.png";